export const WEIGHT_MANAGEMENT_SCORE_BANDS = [
  {
    range: "80 – 100",
    label: "Habits well aligned",
    description: "Weight loss or maintenance very likely",
    color: "text-green-700 dark:text-green-400",
    bg: "bg-green-50 dark:bg-green-950/30",
    border: "border-green-200 dark:border-green-800/40",
    dot: "bg-green-500",
  },
  {
    range: "60 – 79",
    label: "Good, with gaps",
    description: "One or two things pulling you back",
    color: "text-blue-700 dark:text-blue-400",
    bg: "bg-blue-50 dark:bg-blue-950/30",
    border: "border-blue-200 dark:border-blue-800/40",
    dot: "bg-blue-500",
  },
  {
    range: "40 – 59",
    label: "Mixed habits",
    description: "Gains and losses roughly cancelling out",
    color: "text-orange-700 dark:text-orange-400",
    bg: "bg-orange-50 dark:bg-orange-950/30",
    border: "border-orange-200 dark:border-orange-800/40",
    dot: "bg-orange-500",
  },
  {
    range: "Below 40",
    label: "Multiple issues",
    description: "Weight gain likely without changes",
    color: "text-red-700 dark:text-red-400",
    bg: "bg-red-50 dark:bg-red-950/30",
    border: "border-red-200 dark:border-red-800/40",
    dot: "bg-red-500",
  },
] as const;
